import { Stack, styled } from 'tamagui';
export const Container = styled(Stack, {
  bc: '$background',
  paddingHorizontal:12
});
